import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    background: theme.palette.grey[600],
    overflowX: 'scroll',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    height: 68
    // position: 'sticky',
    // top: 0
  },
  singleHeader: {
    minWidth: 120,
    width: '100%'
  },
  channelName: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 50,
    color: theme.palette.primary.contrastText
  },
  subTitles: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3,1fr)',
    background: theme.palette.grey[500],
    alignItems: 'flex-end'
  },
  connect: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12
  },
  rows: {
    display: 'flex',
    flexDirection: 'column'
  }
}))

export default useStyles
